import Box from "@mui/material/Box";
import { Grid } from "@mui/material";
import { IBreakPointProps } from "../../models";
import { LOGIN_SECTION_ID } from "../../constants";

export const BreakPoint = (props: IBreakPointProps) => {
  return (
    <Box
      m={1}
      pt={1}
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "start",
        bgcolor: "inherit",
        maxWidth: "100%",
        background: "#FFFFFF",
      }}>
      <Box
        id={LOGIN_SECTION_ID}
        order={{ xs: 2 }}
        sx={{
          height: "100%",
          width: { md: "50%", xs: "100%" },
        }}>
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="center"
          style={{ minHeight: "80vh" }}>
          <Grid item xs={3}>
            <Box
              sx={{
                height: "100%",
              }}>
              {props.leftElement}
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box
        order={{ xs: 1, sm: 2 }}
        alignItems={"flex-start"}
        m={3}
        pt={3}
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          alignItems: "center",
          m: 3,
          width: { md: "50%" },
          maxWidth: "711px",
        }}
        className="left_container">
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="center"
          style={{ minHeight: "80vh" }}>
          {props.rightElement}
        </Grid>
      </Box>
    </Box>
  );
};
